import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[mstarDashboardOutlet]',
  exportAs: 'dashboardOutlet'
})
export class DashboardOutletDirective {
  @Input() dashboardItem;
  @Input() height;
  @Input() Width;

  constructor(public viewContainerRef: ViewContainerRef) { }
}
